var render = function () {
  var _vm$agent, _vm$agent$actions, _vm$agent2, _vm$agent2$actions, _vm$agent3, _vm$agent3$actions;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "send-info"
  }, [_c('b-modal', {
    attrs: {
      "id": "sendContract",
      "centered": "",
      "size": "lg",
      "hide-footer": "",
      "hide-header-close": "",
      "hide-header": ""
    },
    on: {
      "shown": _vm.getData
    }
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "view-rep-modal-contents mt-3"
  }, [_c('h5', [_c('strong', [_vm._v("Send Representative Contract")])]), _c('div', {
    staticClass: "addMessage-form mt-3"
  }, [_c('div', {
    staticClass: "radio-group mb-3"
  }, _vm._l(_vm.filteredOptions, function (option) {
    return _c('label', {
      key: option,
      staticClass: "radio-label",
      style: {
        visibility: _vm.isLoading ? 'hidden' : 'visible'
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedMainOption,
        expression: "selectedMainOption"
      }],
      staticClass: "radio-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option,
        "checked": _vm._q(_vm.selectedMainOption, option)
      },
      on: {
        "change": [function ($event) {
          _vm.selectedMainOption = option;
        }, function ($event) {
          return _vm.toggleChange(_vm.selectedMainOption);
        }]
      }
    }), _vm._v(" " + _vm._s(_vm.formatOption(option)) + " ")]);
  }), 0)]), _vm.selectedMainOption === 'nonCategoryContract' ? _c('div', {
    staticClass: "row"
  }, [(_vm$agent = _vm.agent) !== null && _vm$agent !== void 0 && (_vm$agent$actions = _vm$agent.actions) !== null && _vm$agent$actions !== void 0 && _vm$agent$actions.is_ben_advance ? [_c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.Abex,
      "name": "checkedLevelABex",
      "count": _vm.contractAgentLevels.Abex - 1 < 0 ? 0 : _vm.contractAgentLevels.Abex - 1,
      "title": "BEX Ancillary Contract",
      "validateInput": false
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.Pbex,
      "name": "checkedLevelPBex",
      "title": "BEX Premier Contract",
      "count": _vm.contractAgentLevels.Pbex - 1 < 0 ? 0 : _vm.contractAgentLevels.Pbex - 1,
      "validateInput": false
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  })] : _vm._e(), !((_vm$agent2 = _vm.agent) !== null && _vm$agent2 !== void 0 && (_vm$agent2$actions = _vm$agent2.actions) !== null && _vm$agent2$actions !== void 0 && _vm$agent2$actions.is_ben_advance) ? [_c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.alc,
      "title": "Smart Contract",
      "name": "checkedLevelAlc",
      "count": _vm.contractAgentLevels.alc,
      "validateInput": false
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.pec,
      "name": "checkedLevelPec",
      "count": _vm.contractAgentLevels.pec,
      "title": "EWA Contract (Union Only)",
      "validateInput": false
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), (_vm$agent3 = _vm.agent) !== null && _vm$agent3 !== void 0 && (_vm$agent3$actions = _vm$agent3.actions) !== null && _vm$agent3$actions !== void 0 && _vm$agent3$actions.is_fegli_contract ? [_c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.fegliAncillary,
      "name": "checkedLevelFAnci",
      "count": _vm.contractAgentLevels.fegliAncillary,
      "title": "GPBP (FEGLI) Contract",
      "validateInput": false
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  })] : _vm._e(), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.patriotAncillary,
      "name": "checkedLevelPAnci",
      "count": _vm.contractAgentLevels.patriotAncillary || _vm.contractAgentLevels.med,
      "title": "Patriot Medical",
      "validateInput": false
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  })] : _vm._e()], 2) : _vm._e(), _vm.selectedMainOption === 'myHealthPlanContract' ? _c('div', {
    staticClass: "row"
  }, [_c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.myHealthPlan,
      "name": "checkedLevelMyHealthPlan",
      "count": _vm.contractAgentLevels.myHealthPlan,
      "title": "My Health Plan",
      "validateInput": false
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  })], 1) : _vm._e(), _c('ValidationObserver', {
    ref: "validationObserver"
  }, [_vm.selectedMainOption === 'categoryContract' ? _c('div', {
    staticClass: "row"
  }, [_c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.med,
      "name": "checkedLevelMedical",
      "count": _vm.contractAgentLevels.med,
      "title": "Medical"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.dent,
      "name": "checkedLevelDental",
      "count": _vm.contractAgentLevels.dent,
      "title": "Dental"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.vision,
      "name": "checkedLevelVision",
      "count": _vm.contractAgentLevels.vision,
      "title": "Vision"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.term_life,
      "name": "checkedLevelTLife",
      "count": _vm.contractAgentLevels.term_life,
      "title": "Term Life"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.bundled,
      "name": "checkedLevelBundles",
      "count": _vm.contractAgentLevels.bundled,
      "title": "Bundles"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.lim_med,
      "name": "checkedLevelLMedical",
      "count": _vm.contractAgentLevels.lim_med,
      "title": "Limited Medical"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.accident,
      "name": "checkedLevelAccident",
      "count": _vm.contractAgentLevels.accident,
      "title": "Accident"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.critical,
      "name": "checkedLevelCritical",
      "count": _vm.contractAgentLevels.critical,
      "title": "Critical"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.hospital,
      "name": "checkedLevelHospital",
      "count": _vm.contractAgentLevels.hospital,
      "title": "Hospital"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.life_style,
      "name": "checkedLevelLStyle",
      "count": _vm.contractAgentLevels.life_style,
      "title": "Life Style"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.pet,
      "name": "checkedLevelPet",
      "count": _vm.contractAgentLevels.pet,
      "title": "Pet"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.guarn_issue,
      "name": "checkedLevelGIssue",
      "count": _vm.contractAgentLevels.guarn_issue,
      "title": "Guaranteed Issue"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.tele_med,
      "name": "checkedLevelTMedicine",
      "count": _vm.contractAgentLevels.tele_med,
      "title": "Telemedicine"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  })], 1) : _vm._e(), _vm.selectedMainOption === 'premierContract' ? _c('div', {
    staticClass: "row"
  }, [_c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.medL7,
      "name": "checkedLevelMedicalL7",
      "count": _vm.contractAgentLevels.medL7,
      "title": "Medical"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.dentL7,
      "name": "checkedLevelDentalL7",
      "count": _vm.contractAgentLevels.dentL7,
      "title": "Dental"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.visionL7,
      "name": "checkedLevelVisionL7",
      "count": _vm.contractAgentLevels.visionL7,
      "title": "Vision"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.term_lifeL7,
      "name": "checkedLevelTLifeL7",
      "count": _vm.contractAgentLevels.term_lifeL7,
      "title": "Term Life"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.bundledL7,
      "name": "checkedLevelBundlesL7",
      "count": _vm.contractAgentLevels.bundledL7,
      "title": "Bundles"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.lim_medL7,
      "name": "checkedLevelLMedicalL7",
      "count": _vm.contractAgentLevels.lim_medL7,
      "title": "Limited Medical"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.accidentL7,
      "name": "checkedLevelAccidentL7",
      "count": _vm.contractAgentLevels.accidentL7,
      "title": "Accident"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.criticalL7,
      "name": "checkedLevelCriticalL7",
      "count": _vm.contractAgentLevels.criticalL7,
      "title": "Critical"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.hospitalL7,
      "name": "checkedLevelHospitalL7",
      "count": _vm.contractAgentLevels.hospitalL7,
      "title": "Hospital"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.life_styleL7,
      "name": "checkedLevelLStyleL7",
      "count": _vm.contractAgentLevels.life_styleL7,
      "title": "Life Style"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.petL7,
      "name": "checkedLevelPetL7",
      "count": _vm.contractAgentLevels.petL7,
      "title": "Pet"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.guarn_issueL7,
      "name": "checkedLevelGIssueL7",
      "count": _vm.contractAgentLevels.guarn_issueL7,
      "title": "Guaranteed Issue"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.tele_medL7,
      "name": "checkedLevelTMedicineL7",
      "count": _vm.contractAgentLevels.tele_medL7,
      "title": "Telemedicine"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.dentSolsticeL7,
      "name": "checkedLevelSolsticeDental7",
      "count": _vm.contractAgentLevels.dentSolsticeL7,
      "title": "Dental-Solstice"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  }), _c('SelectInput', {
    attrs: {
      "contractLevel": _vm.contractLevels.visionSolsticeL7,
      "name": "checkedLevelSolsticeVision7",
      "count": _vm.contractAgentLevels.visionSolsticeL7,
      "title": "Vision-Solstice"
    },
    on: {
      "level-selected": _vm.handleLevelSelected
    }
  })], 1) : _vm._e()]), _c('show-contract-table', {
    staticClass: "mt-5",
    attrs: {
      "items": _vm.actions
    }
  })], 1)]), _c('div', {
    staticClass: "contract-btn-container"
  }, [_c('b-button', {
    staticClass: "univ-btn contract-btn",
    attrs: {
      "variant": "primary",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.validateAndSendEmail
    }
  }, [_vm._v(" Assign ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }